import { render, staticRenderFns } from "./FooterOutfitter.vue?vue&type=template&id=cd2c07ca&scoped=true&"
import script from "./FooterOutfitter.vue?vue&type=script&lang=js&"
export * from "./FooterOutfitter.vue?vue&type=script&lang=js&"
import style0 from "./FooterOutfitter.vue?vue&type=style&index=0&id=cd2c07ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd2c07ca",
  null
  
)

export default component.exports